import {useAtom} from "jotai";
import authenticatedAtom from "../atoms/authenticatedAtom";
import {Button} from "@chakra-ui/react";
import {useNavigate} from "react-router-dom";
import userAtom from "../atoms/userAtom";
import {LuLogOut} from "react-icons/lu";

function Logout(props) {
    const [, setAuthenticated] = useAtom(authenticatedAtom);
    const [, setUser] = useAtom(userAtom);
    const navigate = useNavigate("/");

    const logout = async (event) => {
        event.preventDefault();
        // TODO: Replace with Cognito code
        setAuthenticated(false);
        localStorage.removeItem('token');
        setUser({});
        navigate("/");
    };

    return (
        // <Button {...props} className="agx__logout" onClick={logout}>Log out <LuLogOut /></Button>
        <Button {...props} className="agx__logout" onClick={logout}>Sign Out <LuLogOut/></Button>
    );
}

export default Logout;